import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { api } from "@/lib/api";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Showreel from "@/components/site/Showreel";
import WorkGrid from "@/components/site/WorkGrid";
import OnSet from "@/components/site/OnSet";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Credibility from "@/components/site/Credibility";
import Services from "@/components/site/Services";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import VideoDialog from "@/components/site/VideoDialog";

export default function Home() {
    const [projects, setProjects] = useState(null);
    const [active, setActive] = useState(null);

    useEffect(() => {
        let alive = true;
        const load = (attempt = 0) =>
            api.get("/projects")
                .then((r) => alive && setProjects(r.data))
                .catch(() => {
                    if (attempt < 2) setTimeout(() => alive && load(attempt + 1), 1500);
                    else if (alive) setProjects([]);
                });
        load();
        return () => {
            alive = false;
        };
    }, []);

    const showreel = projects?.find((p) => p.category === "Showreel" && p.video_url) || null;
    const gridProjects = projects ? projects.filter((p) => p.category !== "Showreel") : projects;

    return (
        <div className="bg-paper text-ink">
            <Nav />
            <main>
                <Hero />
                <Showreel project={showreel} onOpen={setActive} />
                <WorkGrid projects={gridProjects} onOpen={setActive} />
                <OnSet onOpen={setActive} />
                <Marquee />
                <About />
                <Credibility />
                <Services />
                <Contact />
            </main>
            <Footer />
            <AnimatePresence>
                {active && <VideoDialog project={active} onClose={() => setActive(null)} />}
            </AnimatePresence>
        </div>
    );
}
